import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { TEMPLATE_IMAGE_URL } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEMPLATE_IMAGE_HEIGHT = 197;
const TEMPLATE_IMAGE_WIDTH = 264;
class TemplatePickerCard extends Component {
  constructor(...args) {
    super(...args);
    this.handleChooseTemplateClick = () => {
      const {
        onChooseTemplateClick,
        templateType
      } = this.props;
      onChooseTemplateClick(templateType);
    };
  }
  render() {
    const {
      currentTemplate,
      templateType
    } = this.props;
    return /*#__PURE__*/_jsx(Clickable, {
      "data-test-id": "template-picker-card",
      "data-test-template-type": templateType,
      onClick: this.handleChooseTemplateClick,
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${templateType}.title`
          })
        }), /*#__PURE__*/_jsx(Image, {
          height: TEMPLATE_IMAGE_HEIGHT,
          src: TEMPLATE_IMAGE_URL[templateType],
          width: TEMPLATE_IMAGE_WIDTH
        }), /*#__PURE__*/_jsx(RadioInput, {
          checked: currentTemplate === templateType,
          padding: "300"
        })]
      })
    });
  }
}
export default TemplatePickerCard;